import { z } from "zod";

export const RequestHelperGetPartnerPrepopInfoInputSchema = z.object({
    partnerId: z.number(),
    needClientEmail: z.boolean(),
});

export type RequestHelperGetPartnerPrepopInfoInput = z.infer<typeof RequestHelperGetPartnerPrepopInfoInputSchema>;